import { render, staticRenderFns } from "./HomePatLegal.vue?vue&type=template&id=469a5dc5"
import script from "./HomePatLegal.vue?vue&type=script&lang=js"
export * from "./HomePatLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports